import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Utility from "../../utility/Utility";
import ActiveInactive from "./ActiveInactive";
import "../../styles/components/Admin/ProfilePictureDetails.scss";
import { Trans } from "react-i18next";
import { PAGE } from "src/constants/page";
import { useNavigate } from "react-router-dom";
import { userAuthId } from "../../redux/reducers/AuthAshaDetailsSlice";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import i18next from "i18next";
import { API } from "src/constants/api";
import { ApiCallWithLoader, errorUpdate } from "src/redux/reducers/LoaderSlice";
import AdminPopUp from "./AdminPopUp";
import { updatedAsha } from "src/redux/reducers/AuthAshaDetailsSlice";

interface ProfilePictureDetailsType {
  userName: string;
  idType: string;
  idDetails: string;
  birthOfDate: string;
  age: string;
  phoneNumber: string;
  userType: string | undefined;
  gender: string;
  status?: string;
  userId?: string;
  userLocation?: string;
  userRole?: string;
}

const profilePicRender = (userType: any, gender: string) => {
  if (userType === "asha") {
    return {
      profileSrc: "/icons/Asha_Profile.svg",
      imageTitle: "asha",
      imageTitleClass: "profileGenderText ashaTextTitleColor",
    };
  } else if (userType === "anm") {
    return {
      profileSrc: "/icons/ANM_Profile.svg",
      imageTitle: "anm",
      imageTitleClass: "profileGenderText ashaTextTitleColor",
    };
  } else if (userType === "patient") {
    return {
      profileSrc: `/icons/${gender}.svg`,
      imageTitle: gender,
      imageTitleClass: `profileGenderText ${gender}TitleColor`,
    };
  } else if (userType === "admin") {
    return {
      profileSrc: "/icons/Admin_Profile.svg",
      imageTitle: "admin",
      imageTitleClass: "profileGenderText adminTitleColor",
    };
  } else if (userType === "global-admin") {
    return {
      profileSrc: "/icons/Global_Admin_Profile.svg",
      imageTitle: "global_admin",
      imageTitleClass: "profileGenderText adminTitleColor",
    };
  } else {
    return {
      profileSrc: "/icons/Profile_Pic_Temp.svg",
      imageTitle: "Admin",
      imageTitleClass: "profileGenderText adminTitleColor",
    };
  }
};

const ProfilePictureDetails = ({
  userName,
  idDetails,
  idType,
  birthOfDate,
  age,
  phoneNumber,
  userType,
  gender,
  status,
  userId,
  userLocation,
  userRole,
}: ProfilePictureDetailsType) => {
  const { profileSrc, imageTitle, imageTitleClass } = profilePicRender(
    userType,
    gender
  );

  const dispatch = useAppDispatch();
  const [actionType, setActionType] = useState("Activate");
  const [showPopUp, setShowPopUp] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [profileStatus, setProfileStatus] = useState<any>(status);

  useEffect(() => {
    dispatch(userAuthId({ userId: userId }));
  }, []);

  const navigate = useNavigate();

  const navigateToDetails = (routeEndValue: string) => {
    const routeLink = PAGE.UPDATE_ASHA;
    navigate(routeLink);
    dispatch(updatedAsha({ updated: false }));
  };

  const handlePopUp = (value: boolean) => {
    setShowPopUp(value);
  };

  const changeStatusFromProfile = async () => {
    try {
      const requestDetails = {
        url: API.USER_CHANGE_STATUS,
        method: "POST",
        callType: "auth0",
        requestData: {
          user_id: userId,
          status: profileStatus === "Inactive" ? "unblock" : "block",
        },
      };
      const resp = await dispatch(ApiCallWithLoader(requestDetails));
      if (resp) {
        handlePopUp(false);
        let updatedStatus = Utility.getStatusValue(
          resp.payload.data.blocked,
          resp.payload.data.app_metadata,
          resp?.payload?.blocked_for
        );
        setProfileStatus(updatedStatus);
        setShowSuccessMessage(true);
      }
    } catch (error) {
      dispatch(errorUpdate({ isError: true, error: error }));
    }
  };

  return (
    <div className="profileMainContainer text-capitalize">
      <div className="profileContainer">
        <div className="profileImageContainer">
          <div className="profileImage ">
            <img src={profileSrc} className="patientDimensions" />
          </div>
          <div className={imageTitleClass}>
            <Trans i18nKey={imageTitle}></Trans>
          </div>
        </div>
        <div className="profileContentContainer">
          <div className="contentTitle" data-testid="testDataUserName">
            {userName}
          </div>
          <div className="contentTitle" data-testid="testIdDetails">
            <Trans i18nKey={idType}></Trans> -{" "}
            {idDetails?.toLowerCase() === "unavailable" ? (
              <Trans i18nKey={"unavailable"} />
            ) : (
              idDetails
            )}
          </div>
          <div className="content">
            <span>{age}</span> |{" "}
            <span>
              <Trans i18nKey={"dob"} />: {Utility.formatDate(birthOfDate)}
            </span>
          </div>
          <div className="content">
            <img src="/icons/contact.svg" alt="contact" />
            {phoneNumber ? phoneNumber : <Trans i18nKey={"unavailable"} />}
          </div>
          {userRole !== "global-admin" &&
            profileStatus !== "Inactive" &&
            userLocation?.includes("viewUsers/asha") && (
              <Button
                data-testid="edit-asha-details"
                type="button"
                onClick={() => navigateToDetails("asha")}
              >
                <Trans i18nKey={"edit_details"}></Trans>
              </Button>
            )}
          {userRole !== "global-admin" && profileStatus !== "Not activated" &&
            userLocation?.includes("viewUsers/asha") && (
              <Button
                className={
                  profileStatus === "Inactive"
                    ? "btn btn-primary statusBtn"
                    : "btn btn-outline statusBtn"
                }
                onClick={() => {
                  setActionType(
                    profileStatus === "Inactive" ? "Activate" : "Deactivate"
                  );
                  handlePopUp(true);
                  setShowSuccessMessage(false);
                }}
              >
                {profileStatus === "Inactive"
                  ? i18next.t("activate")
                  : i18next.t("deactivate")}
              </Button>
            )}
        </div>
      </div>
      <div>
        {status && (
          <ActiveInactive
            statusValue={profileStatus ? profileStatus : status}
            from={"profilePictureDetails"}
          />
        )}
      </div>
      <AdminPopUp
        show={showPopUp}
        handelClose={() => {
          handlePopUp(false);
        }}
        handleOnSubmit={() => {
          changeStatusFromProfile();
        }}
        title_key={`${actionType}_user`}
        body={
          <>
            <Trans i18nKey={"are_you_sure_you_want"} />{" "}
            <span className="text-capitalize">
              <Trans i18nKey={actionType?.toLowerCase()} />
            </span>{" "}
            <b>{userName}</b>?
          </>
        }
        primaryButtonTitle_key={actionType}
        secondaryButtonTitle_key="cancel"
      />
    </div>
  );
};

export default ProfilePictureDetails;
